<template>
  <div>
    <b-row
      class="match-height"
    >
      <b-col
        v-if="activeSubscription"
        sm="12"
        md="12"
      >
        <b-card>
          <b-button
            v-if="!activeSubscription.is_paid"
            variant="primary"
            class="bg-primary p-1 px-3 text-white shadow cursor-pointer"
            style="position:absolute;top:0; right:0;border-radius: 0px 8px 0px 15px;z-index:300;"
            :to="{ name: 'subscribe', params: { id: activeSubscription.id } }"
          >
            <span class="cursor-pointer">Pay Now</span>
          </b-button>
          <b-row class="ma-0 h-full">
            <b-col>
              <b-card-title class="d-flex justify-content-start mt-0 mb-1">
                <h2>Active Subscription</h2>
                <div class="ml-2">
                  <b-badge
                    :variant="`light-${activeSubscription.is_paid ? 'primary' : 'danger'}`"
                  >
                    {{ activeSubscription.is_expire ? 'Expired' : activeSubscription.is_paid ? 'Paid' : 'Unpaid' }}
                  </b-badge>
                </div>
              </b-card-title>
              <h4>Subscription value - {{ activeSubscription.price }}</h4>
              <div class="progress-wrapper">
                <b-card-text class="font-weight-bolder d-flex justify-content-end">
                  {{ subscriptionTimer.remainingDays }} of {{ subscriptionTimer.totalDays }} Days
                </b-card-text>
                <b-progress
                  v-model="subscriptionTimer.remainingDays"
                  max="30"
                />
                <b-card-text class="mt-0">
                  {{ subscriptionTimer.remainingDays }} Day{{ subscriptionTimer.remainingDays > 0 ? 's' : '' }} Remaining
                </b-card-text>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body>
      <b-row class="d-flex justify-content-between align-items-center ml-1 mr-2">
        <b-card-header>
          <h4>All Subscriptions</h4>
        </b-card-header>
        <div>
          <ReportTableButtons
            :items="rows"
            :json_fieldz="json_fields"
            :name="`Subscriptions - Page ${page}.xls`"
            :bulkname="`Subscriptions.xls`"
            :fetch="fetchSubscriptionListNoPagination"
            @refresh="onClickRefresh"
          />
        </div>
      </b-row>
      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              show-empty
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #cell(client_name)="data">
                <div
                  class="d-flex align-items-center"
                >
                  <b-avatar
                    v-if="data.item.logo === null"
                    :text="avatarText(data.value)"
                    size="32"
                    variant="light-primary"
                  />
                  <b-avatar
                    v-else
                    :src="`${data.item.logo}`"
                    size="32"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary"
                    >
                      {{ data.value }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(package.package_name)="data">
                <div
                  class="text-primary"
                  @click="openPackageListModal(data.item.id)"
                >
                  {{ data.value }} Package
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(start_date)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(end_date)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(subscription_status)="data">
                <b-badge :variant="data.value === 'active' ? 'light-success' : (data.value === 'cancelled' || data.value === 'deactivated') ? 'light-warning' : 'light-danger'">
                  {{ data.value === 'active' ? 'ACTIVE' : (data.value === 'cancelled' ? 'CANCELLED' : (data.value === 'deactivated' ? 'DEACTIVATED' : 'EXPIRED')) }}
                </b-badge>
              </template>
            </b-table>
          </b-overlay>

          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <package-list-modal ref="packageListModal" />
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BCard,
  BPagination,
  BTable,
  BOverlay,
  BCardHeader,
  BCardText,
  BCardTitle,
  BButton,
  BBadge,
  // BDropdown,
  // BDropdownItem,
  BProgress,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import PackageListModal from '@/components/subscription/PackageListModal.vue'
import tableMixin from '@core/mixins/tableMixin'

const subscriptionRepository = RepositoryFactory.get('subscription')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BCol,
    BRow,
    BCard,
    BPagination,
    BTable,
    BCardHeader,
    BCardText,
    BBadge,
    BCardTitle,
    BButton,
    BOverlay,
    BProgress,
    vSelect,
    PackageListModal,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      total: 0,
      meta: {},
      dataLoading: false,
      sort: '',
      filters: {},
      subscriptionTimer: {
        total_days: '',
      },
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      fields: [
        {
          key: 'id',
          label: '#',
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'package.package_name',
          label: 'Packages',
          sortable: true,
        },
        {
          key: 'start_date',
          label: 'Start Date',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'end_date',
          label: 'End Date',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'subscription_status',
          label: 'Subscription Status',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'created_at',
          label: 'Created At',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        // {
        //   key: 'action',
        //   label: 'Action',
        //   sortable: false,
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },
      ],
      rows: [],
      activeSubscription: null,
      json_fields: {
        Packages: {
          field: 'package.package_name',
          callback: value => `"${value}"`,
        },
        'Started Date': 'start_date',
        'Subscription Status': 'subscription_status',
        'End Date': 'end_date',
        'Created At': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
      },
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchSubscriptionList()
      },
    },
    page() {
      this.fetchSubscriptionList()
    },
    perPage() {
      this.fetchSubscriptionList()
    },
  },
  async mounted() {
    this.subscriptionId = Number(this.$route.params.id)
  },
  methods: {
    // async fetchActiveSubscription() {
    //   try {
    //     const { data } = (await subscriptionRepository.geActiveSubscription())
    //     this.activeSubscription = data.data
    //     this.subscriptionTimer.totalDays = Math.floor((new Date(this.activeSubscription.ends_at) - new Date(this.activeSubscription.starts_at)) / (1000 * 60 * 60 * 24)) + 1
    //     this.subscriptionTimer.remainingDays = this.subscriptionTimer.totalDays - Math.floor((new Date() - new Date(this.activeSubscription.starts_at)) / (1000 * 60 * 60 * 24)) - 1
    //   } catch (e) {
    //     this.convertAndNotifyError(e)
    //   }
    // },
    async fetchSubscriptionList() {
      this.dataLoading = true
      this.rows = []
      try {
        // eslint-disable-next-line no-underscore-dangle
        const { data } = (await subscriptionRepository.getSubscriptionList(this.page, this.perPage))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchSubscriptionListNoPagination() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        // this.filterQuery = this.__refineDateQuery(this.filterQuery, ['filter[orders.created_at]'])
        const { data } = (await subscriptionRepository.getSubscriptionListNopagination())
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    openPackageListModal(id) {
      this.$refs.packageListModal.openModal(id)
    },
    filterQueryUpdate() {
      this.fetchSubscriptionList()
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchSubscriptionList()
      }
    },
    onClickRefresh() {
      this.fetchSubscriptionList()
      // this.fetchActiveSubscription()
    },
  },
}
</script>
